import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
/**
 * Service used to contact the User
 */
@Injectable({
  providedIn: 'root'
})
export class ContactService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService
  ) {

  }
  /**
   * Get the all template to a customerID
   * @param customerID 
   * @returns 
   */
  getAllTempaltes(customerID: string) {
    return this.http.get(`${this.environment.getApiUrl()}/caseworker/customer/${customerID}/email-candidate`);
  }
  /**
   * send a Notification to a customer by ID
   * @param customerID 
   * @param template 
   * @returns 
   */
  sendNotification(customerID: string, template) {
    return this.http.post(`${this.environment.getApiUrl()}/caseworker/customer/${customerID}/email-candidate`, template);
  }
}
